module.exports = __webpack_public_path__ + "static/media/celebrity.ea344c23.jpg";